import { Toast, Card, ButtonGroup, Divider, Avatar, Badge, Box, Button, InlineGrid, InlineStack, Icon, Link, Tag, Text, BlockStack, Popover, ActionList, Modal, Checkbox, Frame, Grid, Tabs, useBreakpoints } from "@shopify/polaris";
import { dealHasTodos, getBestAvatar, getDaysBetweenDates, getMonthDayString, numberToUSD, shortenNumber } from "../../utils"
import { usePartnerUp } from "../../providers/PartnerUpStoreProvider";

import { ArrowLeftIcon, ArrowRightIcon, ChartFunnelIcon, DiscountIcon, EditIcon, EmailIcon, EnvelopeIcon, LogoInstagramIcon, LogoTiktokIcon, LogoYoutubeIcon, PlusIcon } from '@shopify/polaris-icons';
import { useEffect, useMemo, useState } from "react";
import AppLayout from "../../components/layout";
import CreateCampaign from "../../components/campaigns/CreateCampaign";
import CampaignDetailsReadOnly from "../../components/campaigns/CampaignDetailsReadOnly";
import CampaignFields from "../../components/campaigns/CampaignFields";
import PerformanceGraph from '../../components/PerformanceGraph'
import PostsLibrary from "../../components/PostsLibrary";
import { doc, setDoc } from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllStatusTags } from "../../components/atoms";

function Column({ title, children }) {
  return (
    <div style={{ borderRadius: '10px', background: '#F9FAFB', padding: 10 }}>
      <BlockStack gap="200">
        <InlineStack align="start">
          <Text variant="headingMd">{title}</Text>
        </InlineStack>
        {children}
      </BlockStack>
    </div>
  )
}

function CreatorCard({ creator, code, deal, isOutreach, campaign, allCodes, pastPayments, creatorPosts, setReallyRemove }) {

  const navigate = useNavigate();
  const { mdUp } = useBreakpoints();
  const { setInviteModalState } = usePartnerUp();
  const creatorPlatform = creator.profile?.platform || creator.primaryPlatform
  const [menuOpen, setMenuOpen] = useState(null);
  const [contractOpen, setContractOpen] = useState(false);

  console.log('dealStatus', deal?.status)
  return (
    <Card padding="100">
      <BlockStack gap="200">
        <InlineStack align="space-between">
          <InlineStack gap="100" align="start">
            {isOutreach ? (
              deal?.status === 'opened' ? (
                <InlineStack align="space-between">
                  <Badge progress="partiallyComplete" status="info">Opened {getMonthDayString(new Date(deal?.openedTimestamp))}</Badge>
                </InlineStack>
              ) : deal?.status === 'replied' ? (
                <InlineStack align="space-between">
                  <Badge progress="complete" status="success">Replied {getMonthDayString(new Date(deal?.repliedTimestamp))}</Badge>
                </InlineStack>
              ) : deal?.sentDate ? (
                <InlineStack align="space-between">
                  <Badge progress="partiallyComplete">Contacted {getMonthDayString(new Date(deal?.sentDate))}</Badge>
                </InlineStack>
              ) : (
                <InlineStack align="space-between">
                  <Badge progress="incomplete">Not Contacted</Badge>
                </InlineStack>
              )
            ) : null}

            {
              getAllStatusTags(deal, allCodes, 'horizontal', pastPayments, creatorPosts)
            }
          </InlineStack>
          <Popover active={menuOpen} activator={<Button variant="plain" onClick={() => setMenuOpen(true)} size="slim" plain>...</Button>} onClose={() => { setMenuOpen(false) }}>
            <ActionList items={isOutreach && deal?.status !== 'replied' ? [
              {
                content: 'Send Contract',
                onAction: () => setInviteModalState({
                  open: true,
                  campaign,
                  inviteType: 'invite',
                  inviting: [creator]
                })
              },
              {
                content: 'Remove from Campaign',
                onAction: () => setReallyRemove({ deal, isOutreach, creator, code })
              },
            ] : [
              {
                content: 'Remove from Campaign',
                onAction: () => setReallyRemove({ deal, isOutreach, creator, code })
              },
            ]} />
          </Popover>
        </InlineStack>
        <Divider />
        <BlockStack gap="200">
          <BlockStack inlineAlign="start" align="start" gap="200">
            <InlineStack gap="200" blockAlign="center" align="start">
              <Avatar size="xl" shape="square" initials={creator.name?.[0]} source={getBestAvatar(creator)} />
              <BlockStack>
                <InlineStack gap="100" blockAlign="center">
                  <Link removeUnderline onClick={() => {
                    navigate(`/creators/?id=${creator.id}`)
                  }}>
                    <Text variant="headingMd">{creator.name}</Text>
                  </Link>
                  <InlineStack align="start" blockAlign="center" gap="100">
                    {
                      creatorPlatform === 'instagram' ? (
                        <Icon source={LogoInstagramIcon} />
                      ) : creatorPlatform === 'tiktok' ? (
                        <Icon source={LogoTiktokIcon} />
                      ) : creatorPlatform === 'youtube' ? (
                        <Icon source={LogoYoutubeIcon} />
                      ) : null
                    }
                    <Text color="subdued">
                      {creator.profile?.profile?.followers ? `${shortenNumber(creator.profile?.profile?.followers)}` : ''}
                    </Text>
                  </InlineStack>
                </InlineStack>
                <Text>{creator?.email || 'No Email'}</Text>
              </BlockStack>
            </InlineStack>
          </BlockStack>
          <Divider />
          {
            isOutreach ? (
              <InlineStack align="space-between">
                {
                  !deal?.sentDate ? (
                    <Button size='micro' onClick={() => {
                      setInviteModalState({
                        open: true,
                        campaign,
                        inviteType: 'outreach',
                        inviting: [creator]
                      })
                    }} icon={EnvelopeIcon}>Contact</Button>
                  ) : (
                    <Button size='micro' onClick={() => {
                      navigate('/emails/?id=' + creator.id)
                    }} icon={EmailIcon}>Email</Button>
                  )
                }
                <Button size='micro' onClick={() => {
                  setInviteModalState({
                    open: true,
                    campaign,
                    inviteType: 'contract',
                    inviting: [creator]
                  })
                }} icon={ArrowRightIcon}>Create Contract</Button>
              </InlineStack>
            ) : null
          }
          {
            !isOutreach && deal?.status === 'invited' ? (
              <>
                <InlineStack gap="100" align="end">
                  {
                    /*
                    <Button size='micro' onClick={() => handleCampaignInvite([creator], campaign, 'outreach')} icon={EditMinor}>Edit</Button>
                      */
                  }
                  <Popover
                    active={contractOpen}
                    onClose={() => {
                      setContractOpen(false)
                    }}
                    activator={
                      <Button size='micro' onClick={() => {
                        setContractOpen(true)
                      }} disclosure>
                        Contract
                      </Button>
                    }>
                    <ActionList items={[
                      {
                        content: 'Send', onAction: () => {
                          setInviteModalState({
                            open: true,
                            campaign,
                            inviteType: 'invite',
                            inviting: [creator]
                          })
                        }
                      },
                      { content: 'View & Edit', onAction: () => navigate('/creators?id=' + creator.id) },
                    ]} actionRole="menuitem" />
                  </Popover>
                </InlineStack>
              </>
            ) : null
          }
          {
            !isOutreach && code?.code ? (
              <Card background="bg-subdued" padding="1">
                <InlineStack align="center" inlineAlign="center">
                  <InlineStack>
                    <Icon source={DiscountIcon} color="subdued" />
                  </InlineStack>
                  {
                    code?.code
                  }
                </InlineStack>
              </Card>
            ) : null
          }
          <InlineGrid columns="2" align="space-between">
            {
              deal?.revenue || deal?.costs?.total ? (
                <>
                  {
                    code?.code ? (
                      <Card background="bg-subdued" padding="1">
                        <BlockStack align="center" inlineAlign="center">
                          <Text color="success">{numberToUSD(deal.revenue || 0, store?.paymentSettings?.currencyCode, 0)}</Text>
                          <Text>Revenue</Text>
                        </BlockStack>
                      </Card>
                    ) : null
                  }
                  <Card background="bg-subdued" padding="1">
                    <BlockStack align="center" inlineAlign="center">
                      <Text color="critical">{numberToUSD(deal.costs?.total || 0, store?.paymentSettings?.currencyCode, 0)}</Text>
                      <Text>Cost</Text>
                    </BlockStack>
                  </Card>
                </>
              ) : null
            }
          </InlineGrid>
        </BlockStack>
      </BlockStack>
    </Card>
  )
}

export default function CampaignKanban({ handleCreatorClick, handleChangeDeal }) {
  const { deals, leads, setToast, db, allCodes, archiveInvite, creatorPosts, archiveDeal, content, campaigns, pastPayments, store, outreachInvites } = usePartnerUp();

  const { mdUp } = useBreakpoints();
  const navigate = useNavigate();
  const location = useLocation()
  const [cpTab, setCpTab] = useState(1)

  const [mobileTab, setMobileTab] = useState(0)

  const [saveLoading, setSaveLoading] = useState(false)

  const campaignID = location.pathname.split('/').pop()
  console.log('campaignID', campaignID)

  const campaign = campaigns?.find(c => c.id === campaignID);
  const campaignDeals = deals?.filter(deal => deal.campaignID === campaignID && deal.status !== 'archived')
  const campaignOutreachInvites = outreachInvites?.filter(invite => invite.campaignID === campaignID)

  const [localCampaign, setLocalCampaign] = useState(campaign)
  const [script, setScript] = useState(campaign?.specs?.script || '')
  const [creativeDirection, setCreativeDirection] = useState(campaign?.specs?.creativeDirection || '')
  const [inspiration, setInspiration] = useState(campaign?.specs?.inspiration || '')

  console.log('outreachInvites', outreachInvites)

  useEffect(() => {
    if (campaigns?.length) {
      const campaign = campaigns?.find(c => c.id === campaignID);
      setLocalCampaign(campaign)
      setScript(campaign?.specs?.script || '')
      setCreativeDirection(campaign?.specs?.creativeDirection || '')
      setInspiration(campaign?.specs?.inspiration || '')
    }
  }, [campaignID])

  function handleLocalCampaignChange(k, value) {
    const [key, subKey] = k.split('.');
    if (key === 'script') {
      setScript(value)
    } else if (key === 'creativeDirection') {
      setCreativeDirection(value)
    } else if (key === 'inspiration') {
      setInspiration(value)
    } else if (subKey) {
      setLocalCampaign({
        ...localCampaign,
        [key]: {
          ...localCampaign[key],
          [subKey]: value
        }
      })
    } else {
      setLocalCampaign({
        ...localCampaign,
        [key]: value
      })
    }
  }

  const [reallyRemove, setReallyRemove] = useState(null);
  const [removeLoading, setRemoveLoading] = useState(false);
  const [deleteAffiliateCodes, setDeleteAffiliateCodes] = useState(false);
  const [createCampaign, setCreateCampaign] = useState(false);

  const invited = campaignDeals?.filter(deal => deal.status === "invited");

  let lastDate = new Date();
  let firstDate = new Date();

  lastDate.setHours(24, 0, 0, 0)

  campaignDeals?.forEach(deal => {
    if (new Date(deal?.created) < firstDate) {
      firstDate = new Date(deal?.created)
    }
  })

  const campaignInvites = outreachInvites.filter(invite => invite.campaignID === campaignID)
  const currentInvites = campaignInvites
    ?.filter(invite => !campaignDeals?.some(c => c.creatorID === invite.creatorID))

  campaignInvites?.forEach(inv => {
    if (new Date(inv?.sentDate) < firstDate) {
      firstDate = new Date(inv?.sentDate)
    }
  })

  const sevenDaysAgoDate = new Date()
  sevenDaysAgoDate.setDate(sevenDaysAgoDate.getDate() - 7)

  const days = getDaysBetweenDates(sevenDaysAgoDate, lastDate)
  const revenueTimeSeries = Array(days?.length).fill(0)
  const costsTimeSeries = Array(days?.length).fill(0)
  const creatorsTimeSeries = Array(days?.length).fill(0)
  const invitesTimeSeries = Array(days?.length).fill(0)
  const postsTimeSeries = Array(days?.length).fill(0)
  const engagementsTimeSeries = Array(days?.length).fill(0)
  const clicksTimeSeries = Array(days?.length).fill(0)

  let totalEngagements = 0;
  let totalClicks = 0;

  campaignInvites?.forEach(invite => {
    const dateString = getMonthDayString(new Date(invite?.sentDate))
    const dateIndex = days.indexOf(dateString)
    invitesTimeSeries[dateIndex] += 1
  })

  const todos = []
  const active = [];
  campaignDeals.forEach(deal => {
    if (deal?.status === 'archived') return;

    const dateString = getMonthDayString(new Date(deal?.created))
    const dateIndex = days.indexOf(dateString)
    creatorsTimeSeries[dateIndex] += 1

    if (deal?.status === 'invited') return;
    const creatorID = deal.creatorID;
    const dealCodes = allCodes?.filter(code => code.dealID === deal.id);
    const dealContent = creatorPosts?.filter(content => content.dealID === deal.id);
    const creatorCampaignPayments = pastPayments?.filter(payment => payment.creatorID === creatorID && payment.campaignID === campaignID)
    let revenue = 0
    let costs = {
      productCost: 0,
      shippingCost: 0,
      fixedPayments: 0,
      commission: 0,
    };

    dealCodes?.forEach(code => {
      code.orders?.forEach(order => {

        const orderRevenue = Number(order.subtotalPriceSet?.shopMoney?.amount || 0)
        revenue += orderRevenue
        const dateString = getMonthDayString(new Date(order?.processedAt))
        const dateIndex = days.indexOf(dateString)
        revenueTimeSeries[dateIndex] += orderRevenue

        if (code?.commission) {
          costs.commission += Number(order.subtotalPriceSet?.shopMoney?.amount || 0) * (code.commission / 100)
          costsTimeSeries[dateIndex] += Number(order.subtotalPriceSet?.shopMoney?.amount || 0) * (code.commission / 100)
        }
      })
    })

    if (deal?.order) {
      costs.productCost = deal.order.totalCost || 0
      costs.shippingCost = deal.order.shippingCost || 0
      const giftOrderDate = getMonthDayString(new Date(deal?.order?.processedAt))
      const dateIndex = days.indexOf(giftOrderDate)
      costsTimeSeries[dateIndex] += (deal.order.totalCost || 0) + (deal.order.shippingCost || 0)
    }

    creatorCampaignPayments?.forEach(payment => {
      costs.fixedPayments += Number(payment.value)
      const paymentDate = getMonthDayString(new Date(payment?.date))
      const dateIndex = days.indexOf(paymentDate)
      costsTimeSeries[dateIndex] += Number(payment.value)
    })

    costs.total = costs.productCost + costs.shippingCost + costs.fixedPayments + costs.commission

    if (dealHasTodos(deal, dealCodes, dealContent)) {
      todos.push({ ...deal, revenue, costs });
    } else {
      active.push({ ...deal, revenue, costs });
    }
  })

  const posts = creatorPosts?.filter(post => post.campaignID === campaignID) || []
  posts?.forEach(post => {
    const dateString = getMonthDayString(new Date(post?.timestamp * 1000))
    const dateIndex = days.indexOf(dateString)
    postsTimeSeries[dateIndex] += 1
  })

  const graphs = useMemo(() => (
    <InlineGrid columns="6" gap="300">
      <PerformanceGraph noAxes={true} title={`${campaignInvites?.length} Creators`} height="45px" label="Creators" timeSeriesRaw={invitesTimeSeries} typeTab={2} labels={days} />
      <PerformanceGraph noAxes={true} title={`${posts?.length} Posts`} height="45px" label="Posts" timeSeriesRaw={postsTimeSeries} typeTab={2} labels={days} />
      <PerformanceGraph noAxes={true} title={`${shortenNumber(totalEngagements)} Engagements`} height="45px" label="Engagements" timeSeriesRaw={engagementsTimeSeries} typeTab={2} labels={days} />
      <PerformanceGraph noAxes={true} title={`${totalClicks} Clicks`} height="45px" label="Clicks" timeSeriesRaw={clicksTimeSeries} typeTab={2} labels={days} />
      <PerformanceGraph noAxes={true} title={`${numberToUSD(costsTimeSeries?.reduce((acc, v) => acc + v), store?.paymentSettings?.currencyCode)} Cost`} height="45px" label="Cost" timeSeriesRaw={costsTimeSeries} typeTab={1} labels={days} />
      <PerformanceGraph noAxes={true} label="Revenue" title={`${numberToUSD(revenueTimeSeries?.reduce((acc, v) => acc + v), store?.paymentSettings?.currencyCode, 0)} Revenue`} height="45px" timeSeriesRaw={revenueTimeSeries} typeTab={1} labels={days} />
    </InlineGrid>
  ), [])

  if (createCampaign) {
    return (
      <AppLayout>
        <CreateCampaign onClose={() => setCreateCampaign(false)} />
      </AppLayout>
    )
  }
  if (!campaigns?.length) {
    return (
      <AppLayout>
        <Card>
          <BlockStack gap="300" inlineAlign="center">
            <Text variant="headingLg">No Campaigns Yet</Text>
            <Text>Start a campaign to get started</Text>
            <Button primary onClick={() => setCreateCampaign(true)}>Create Campaign</Button>
          </BlockStack>
        </Card>
      </AppLayout>
    )
  }

  console.log('campaign', campaign)

  const header = (
    <BlockStack gap="500">
      <InlineStack gap="100" align="space-between">
        <InlineStack gap="200" blockAlign="center">
          <Button icon={ArrowLeftIcon} onClick={() => navigate(-1)}></Button>
          <Icon source={ChartFunnelIcon} />
          <Text variant="headingLg">{campaign?.campaignTitle}</Text>
        </InlineStack>
        {
          cpTab === 0 ? (
            <ButtonGroup>
              <Button icon={PlusIcon} onClick={async () => {
                navigate('/creators')
              }}>Invite Creators</Button>
              <Button icon={EditIcon} onClick={async () => {
                setCpTab(1)
              }}>View & Edit</Button>
            </ButtonGroup>
          ) : (
            <ButtonGroup>
              <Button loading={saveLoading} variant="primary" onClick={async () => {
                try {
                  setSaveLoading(true)
                  await setDoc(doc(db, 'campaigns', campaignID), {
                    ...localCampaign,
                    specs: {
                      ...localCampaign?.specs,
                      script,
                      creativeDirection,
                      inspiration
                    }
                  })
                  setToast({ content: 'Campaign saved', error: false })
                } catch (e) {
                  console.error(e)
                  alert('Error saving campaign')
                } finally {
                  setSaveLoading(false)
                }
              }}>Save Changes</Button>
            </ButtonGroup>
          )
        }
      </InlineStack>
      {
        !mdUp ? (
          <Card padding="0">
            <InlineStack align="space-between">
              <Tabs fitted tabs={[
                { content: 'Preview', id: 'posts' },
                { content: 'Edit', id: 'edit' },
              ]} selected={mobileTab} onSelect={v => setMobileTab(v)} />
            </InlineStack>
          </Card>
        ) : null
      }
      {
        /*
        <Card padding="0">
          <Tabs tabs={[
            { content: 'Creators', id: 'creators' },
            { content: 'Details', id: 'details' },
            { content: 'Posts', id: 'posts' },
          ]} selected={cpTab} onSelect={v => setCpTab(v)} />
        </Card>
          */
      }
    </BlockStack>
  )

  if (cpTab === 1) {
    return (
      <AppLayout>
        <BlockStack gap="500">
          {header}
          {
            mdUp ? (
              <InlineGrid columns="2" gap="300">
                <CampaignDetailsReadOnly deal={localCampaign} />
                <CampaignFields localCampaign={{
                  ...localCampaign,
                  specs: {
                    ...localCampaign?.specs,
                    script,
                    creativeDirection,
                    inspiration
                  }
                }} handleLocalCampaignChange={handleLocalCampaignChange} />
              </InlineGrid>
            ) : (
              mobileTab === 0 ? (

                <CampaignDetailsReadOnly deal={localCampaign} />
              ) : (

                <CampaignFields localCampaign={{
                  ...localCampaign,
                  specs: {
                    ...localCampaign?.specs,
                    script,
                    creativeDirection,
                    inspiration
                  }
                }} handleLocalCampaignChange={handleLocalCampaignChange} />
              )
            )
          }
        </BlockStack>
      </AppLayout>
    )
  } else if (cpTab === 2) {
    return (
      <AppLayout>
        <BlockStack gap="500">
          {header}
          <PostsLibrary posts={posts} />
        </BlockStack>
      </AppLayout>
    )
  }

  if (!campaignDeals?.length && !campaignOutreachInvites?.length) {
    return (
      <AppLayout>
        <BlockStack gap="500">
          {header}
          <InlineGrid columns="3" gap="500">
            <Box />
            <Box paddingBlockStart="10">
              <Card>
                <BlockStack gap="300" inlineAlign="center">
                  <BlockStack gap="100" inlineAlign="center">
                    <Text variant="headingLg">No Creators Yet</Text>
                    <Text>Invite creators to this campaign to get started</Text>
                  </BlockStack>
                  <ButtonGroup>
                    <Button primary onClick={() => navigate('/creators')}>Invite Creators</Button>
                    <Button onClick={() => setCpTab(1)}>View Details</Button>
                  </ButtonGroup>
                  <Link external removeUnderline url="https://partnerup.helpscoutdocs.com/article/15-sending-campaign-invites">Learn How to Add Creators</Link>
                </BlockStack>
              </Card>
            </Box>
          </InlineGrid>
        </BlockStack>
      </AppLayout>
    )
  }

  return (
    <AppLayout>
      <BlockStack gap="500">
        <Modal title={`Remove ${reallyRemove?.creator?.name}?`} open={reallyRemove} onClose={() => setReallyRemove(null)} primaryAction={{
          content: 'Remove',
          loading: removeLoading,
          destructive: true,
          onAction: async () => {
            try {
              console.log('reallyRemove', reallyRemove)
              setRemoveLoading(true)
              if (reallyRemove?.isOutreach) {
                console.log('archiveInvite', reallyRemove?.id)
                await archiveInvite(reallyRemove?.deal?.id)
              } else {
                await archiveDeal({ deal: reallyRemove?.deal, deleteAffiliateCodes })
                const invite = campaignInvites.find(i => i.creatorID === reallyRemove?.deal?.creatorID)
                if (invite) {
                  await archiveInvite(invite?.id)
                }
              }
              setToast({ content: 'Creator removed', error: false })
            } catch (e) {
              console.log('error', e)
              setToast({ content: 'Error removing creator', error: true })
            } finally {
              setRemoveLoading(false)
              setReallyRemove(null)
            }
          }
        }} secondaryActions={[
          {
            content: 'Cancel',
            onAction: () => setReallyRemove(null)
          }
        ]}>
          <Modal.Section>
            <BlockStack gap="300">
              <Text>Are you sure you want to remove {reallyRemove?.creator?.name} from the campaign?</Text>
              <Text>This action cannot be undone.</Text>
              {
                reallyRemove?.code?.code ? (
                  <Checkbox label="Also delete affiliate codes" checked={deleteAffiliateCodes} onChange={() => setDeleteAffiliateCodes(!deleteAffiliateCodes)} />
                ) : null
              }
            </BlockStack>
          </Modal.Section>
        </Modal>
        {header}
        {graphs}
        <InlineGrid gap="300" columns="4" alignItems="start">
          <Column title="Action Required">
            {
              currentInvites?.filter(i => i?.status === 'replied').map(deal => {
                const creator = leads.find(lead => lead.id === deal.creatorID);
                function handleClick() {
                  handleCreatorClick(creator)
                  handleChangeDeal({ ...deal, isInvite: isOutreach })
                }
                return <CreatorCard
                  campaign={campaign}
                  pastPayments={pastPayments}
                  handleClick={handleClick}
                  creatorPosts={creatorPosts}
                  creator={creator}
                  key={deal.id}
                  deal={deal}
                  isOutreach={true}
                  isReplied={true}
                  leads={leads}
                  allCodes={allCodes}
                  setReallyRemove={setReallyRemove}
                />
              })
            }
            {
              todos?.map(deal => {
                const creator = leads.find(lead => lead.id === deal.creatorID);
                const code = allCodes.find(code => code.dealID === deal.id && code?.isActiveCode === true);
                function handleClick() {
                  handleCreatorClick(creator)
                  handleChangeDeal({ ...deal, isInvite: isOutreach })
                }
                return <CreatorCard
                  campaign={campaign}
                  setReallyRemove={setReallyRemove}
                  pastPayments={pastPayments}
                  creatorPosts={creatorPosts}
                  handleClick={handleClick} creator={creator} code={code} key={deal.id} deal={deal} leads={leads} allCodes={allCodes} />

              })
            }
          </Column>
          <Column title="Outreach Stage">
            {
              currentInvites?.filter(i => i?.status !== 'replied').map(deal => {
                function handleClick() {
                  handleCreatorClick(creator)
                  handleChangeDeal({ ...deal, isInvite: isOutreach })
                }
                const creator = leads.find(lead => lead.id === deal.creatorID);
                return <CreatorCard
                  campaign={campaign}
                  setReallyRemove={setReallyRemove}
                  pastPayments={pastPayments}
                  creatorPosts={creatorPosts}
                  handleClick={handleClick} creator={creator} key={deal.id} deal={deal} isOutreach={true} leads={leads} allCodes={allCodes} />
              })
            }
          </Column>
          <Column title="Contract Stage">
            {
              invited?.map(deal => {
                function handleClick() {
                  handleCreatorClick(creator)
                  handleChangeDeal({ ...deal, isInvite: isOutreach })
                }
                const creator = leads.find(lead => lead.id === deal.creatorID);
                return <CreatorCard
                  pastPayments={pastPayments}
                  campaign={campaign}
                  setReallyRemove={setReallyRemove}
                  creatorPosts={creatorPosts}
                  handleClick={handleClick} creator={creator} key={deal.id} deal={deal} leads={leads} allCodes={allCodes} />

              })
            }
          </Column>
          <Column title="Active">
            {
              active?.map(deal => {
                function handleClick() {
                  handleCreatorClick(creator)
                  handleChangeDeal({ ...deal, isInvite: isOutreach })
                }
                const creator = leads.find(lead => lead.id === deal.creatorID);
                const code = allCodes.find(code => code.dealID === deal.id && code?.isActiveCode === true);
                return <CreatorCard
                  pastPayments={pastPayments}
                  campaign={campaign}
                  setReallyRemove={setReallyRemove}
                  creatorPosts={creatorPosts}
                  handleClick={handleClick} creator={creator} code={code} key={deal.id} deal={deal} leads={leads} allCodes={allCodes} />
              })
            }
          </Column>
        </InlineGrid>
      </BlockStack>
    </AppLayout>
  )
}
